export default "__VITE_ASSET__BU_OAhpP__"